import { connect, ConnectedProps } from "react-redux";
import { AppDispatch, RootState } from "store";
import { RejectInvoice } from "./RejectInvoice";
import { RejectInvoiceContainerProps, RejectInvoiceForm } from "./types";
import { actions, preliquidationSelector } from "reducers/preliquidation";
import { validationSchema } from "./schemas";
import { RejectInvoiceMiddlewareType } from "sagas/types/preliquidation";
import { useEffect, useRef } from "react";
import { PagesPreliquidationTypes } from "../types";
import { useParams } from "react-router-dom";
import { BULK_FLOW_ID } from "utils/constants";
import { FormRefType } from "utils/types";

const RejectInvoiceContainer = (
  props: RejectInvoiceContainerProps & ConnectorProps
): JSX.Element => {
  const formRef: FormRefType<RejectInvoiceForm> = useRef(null);
  const params: { id?: string } = useParams();

  const onClose = () => {
    props.onCloseModal();
  };

  const onSubmit = (values: RejectInvoiceForm) => {
    const { currentInvoice, invoiceIds } = props;
    const len = invoiceIds?.length;
    let presettlementId = props.preliquidation.id;
    if (params.id === BULK_FLOW_ID && len > 0 && currentInvoice < len) {
      presettlementId = invoiceIds[currentInvoice];
    }

    props.deleteInvoiceDetail({
      presettlementId,
      reason: {
        rejectedReason: values.reason.tag,
        message: values.message || null,
      },
      onErrorHandler: () => props.setActualPage("preliquidation"),
    });
  };
  useEffect(() => {
    if (props.isOpen && props.rejectedReasons.length === 0)
      props.getRejectedReason();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isOpen, props.rejectedReasons]);

  useEffect(() => {
    if (formRef.current) formRef.current.restart();
  }, [props.isOpen]);

  return (
    <RejectInvoice
      {...props}
      validationSchema={validationSchema}
      onClose={onClose}
      onSubmit={onSubmit}
      formRef={formRef}
      testId="reject-invoice"
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  preliquidation: preliquidationSelector(state).detailPreliquidations,
  rejectedReasons: preliquidationSelector(state).rejectedReasons,
  currentInvoice: preliquidationSelector(state).currentInvoice,
  invoiceIds: preliquidationSelector(state).pendingApprovalPresettlements,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  setActualPage: (page: PagesPreliquidationTypes) => {
    dispatch(actions.setActualPage(page));
  },
  onCloseModal: () => {
    dispatch(actions.toggleRejectInvoiceModalVisibility(false));
  },
  deleteInvoiceDetail: (value: RejectInvoiceMiddlewareType) => {
    dispatch(actions.deleteInvoiceDetailRequest(value));
  },
  getRejectedReason: () => {
    dispatch(actions.getRejectedReasonRequest());
  },
});

const connector = connect(mapStateToProps, mapDispatchToProps);

type ConnectorProps = ConnectedProps<typeof connector>;

export default connector(RejectInvoiceContainer);
